import { dataChevronLeft } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronLeft = /*#__PURE__*/createIcon(dataChevronLeft)
export default IconChevronLeft
